import {
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Popper,
  Select,
  TextField,
} from "@mui/material";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { JiraConfigureTicketAction } from "../../../../utils/constants";

const JiraConfigureTicket = ({ jiraState, action }) => {
  return (
    <>
      {jiraState.projectOptions && (
        <Autocomplete
          options={jiraState.projectOptions}
          disabled={jiraState.loadedFields["projects"] === false}
          getOptionLabel={(option) => option.name}
          value={jiraState.selectedProject}
          onChange={(event, newValue) => jiraState.setSelectedProject(newValue)}
          PopperComponent={({ children, ...props }) => {
            const { anchorEl } = props;
            const width = anchorEl ? anchorEl.offsetWidth : undefined;
            return (
              <Popper {...props} style={{ minWidth: width }}>
                {children}
              </Popper>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              label="Project name"
              fullWidth
            />
          )}
        />
      )}
      {jiraState.issueTypes && (
        <Autocomplete
          options={jiraState.issueTypes}
          getOptionLabel={(option) => option.name}
          value={jiraState.selectedIssueType}
          onChange={(event, newValue) =>
            jiraState.setSelectedIssueType(newValue)
          }
          PopperComponent={({ children, ...props }) => {
            const { anchorEl } = props;
            const width = anchorEl ? anchorEl.offsetWidth : undefined;
            return (
              <Popper {...props} style={{ minWidth: width }}>
                {children}
              </Popper>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              label="Issue type"
              fullWidth
            />
          )}
        />
      )}
      {(action === JiraConfigureTicketAction.CREATE ||
        action === JiraConfigureTicketAction.EDIT) && (
        <>
          <TextField
            autoFocus
            margin="dense"
            label="Issue Summary"
            fullWidth
            value={jiraState.issueSummary}
            onChange={(e) => jiraState.setIssueSummary(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Issue Description"
            fullWidth
            multiline
            rows={4}
            value={jiraState.issueDescription}
            onChange={(e) => jiraState.setIssueDescription(e.target.value)}
          />
        </>
      )}

      {/* Generate <TextFields> based on the custom_field list. for each required field create a TextField */}
      {/* Generate the right MUI HTML Element based on the customfield.schema.type (it can be array, number,  ) */}
      {action !== JiraConfigureTicketAction.EDIT &&
        jiraState.customFieldList.map((customField) => {
          switch (customField.schema.type) {
            case "string":
              return (
                <TextField
                  autoFocus
                  margin="dense"
                  label={customField.name}
                  fullWidth
                  required={customField.required}
                  onChange={(event) =>
                    jiraState.setCustomFieldsValues({
                      ...jiraState.customFieldsValues,
                      [customField.key]: event.target.value,
                    })
                  }
                />
              );
            case "number":
              return (
                <TextField
                  autoFocus
                  margin="dense"
                  label={customField.name}
                  fullWidth
                  required={customField.required}
                  type="number"
                  onChange={(event) =>
                    jiraState.setCustomFieldsValues({
                      ...jiraState.customFieldsValues,
                      [customField.key]: event.target.value,
                    })
                  }
                />
              );
            case "option":
              return (
                <FormControl fullWidth margin="dense">
                  <InputLabel>{customField.name}</InputLabel>
                  <Select
                    autoFocus
                    margin="dense"
                    label={customField.name}
                    fullWidth
                    required={customField.required}
                    onChange={(event) => {
                      jiraState.setCustomFieldsValues({
                        ...jiraState.customFieldsValues,
                        [customField.key]: event.target.value,
                      });
                    }}
                  >
                    {customField.allowedValues.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              );
            case "array":
              return (
                <Autocomplete
                  options={customField.allowedValues.map(({ value, id }) => ({
                    value,
                    id,
                  }))}
                  getOptionLabel={(option) => option.value}
                  value={
                    jiraState.customFieldsValues
                      ? jiraState.customFieldsValues[customField.key]
                      : []
                  }
                  multiple
                  filterSelectedOptions
                  onChange={(event, newValue) => {
                    const newCustomFieldsValues = jiraState.customFieldsValues;
                    newCustomFieldsValues[customField.key] = newValue.map(
                      (item) => item.id
                    );
                    jiraState.setCustomFieldsValues(newCustomFieldsValues);
                  }}
                  PopperComponent={({ children, ...props }) => {
                    const { anchorEl } = props;
                    const width = anchorEl ? anchorEl.offsetWidth : undefined;
                    return (
                      <Popper {...props} style={{ minWidth: width }}>
                        {children}
                      </Popper>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="dense"
                      label={customField.name}
                      fullWidth
                    />
                  )}
                />
              );
            default:
              return null;
          }
        })}
      <Autocomplete
        options={jiraState.assigneeOptions}
        getOptionLabel={(option) => option.displayName || option}
        value={jiraState.assignee}
        disabled={jiraState.loadedFields["assignees"] === false}
        onChange={(event, newValue) =>
          jiraState.setAssignee(newValue.displayName)
        }
        PopperComponent={({ children, ...props }) => {
          const { anchorEl } = props;
          const width = anchorEl ? anchorEl.offsetWidth : undefined;
          return (
            <Popper {...props} style={{ minWidth: width }}>
              {children}
            </Popper>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} margin="dense" label="Assignee" fullWidth />
        )}
      />
      {action === JiraConfigureTicketAction.CREATE && (
        <Autocomplete
          options={jiraState.labelOptions}
          value={jiraState.defaultLabels}
          multiple
          freeSolo
          filterSelectedOptions
          disabled={jiraState.loadedFields["labels"] === false}
          onChange={(event, newValue) => jiraState.setDefaultLabels(newValue)}
          PopperComponent={({ children, ...props }) => {
            const { anchorEl } = props;
            const width = anchorEl ? anchorEl.offsetWidth : undefined;
            return (
              <Popper {...props} style={{ minWidth: width }}>
                {children}
              </Popper>
            );
          }}
          renderInput={(params) => (
            <TextField {...params} margin="dense" label="Labels" fullWidth />
          )}
        />
      )}
      {action !== JiraConfigureTicketAction.CREATE && (
        <Autocomplete
          options={jiraState.labelOptions}
          value={jiraState.labels}
          multiple
          freeSolo
          filterSelectedOptions
          disabled={jiraState.loadedFields["labels"] === false}
          onChange={(event, newValue) => jiraState.setLabels(newValue)}
          PopperComponent={({ children, ...props }) => {
            const { anchorEl } = props;
            const width = anchorEl ? anchorEl.offsetWidth : undefined;
            return (
              <Popper {...props} style={{ minWidth: width }}>
                {children}
              </Popper>
            );
          }}
          renderInput={(params) => (
            <TextField {...params} margin="dense" label="Labels" fullWidth />
          )}
        />
      )}

      <Checkbox
        checked={jiraState.includeEntitiesCSV}
        onChange={(e) =>
          jiraState.setIncludeEntitiesCSV(!jiraState.includeEntitiesCSV)
        }
      />
      <span style={{ fontSize: "12px" }}>
        Include involved entities csv file as attachment
      </span>
      <br></br>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {action === JiraConfigureTicketAction.CONFIGURE && (
          <PrimaryButton
            onClick={jiraState.handleSaveIssueConfig}
            style={{ textTransform: "none" }}
          >
            Save Configuration
          </PrimaryButton>
        )}
      </div>
    </>
  );
};
export default JiraConfigureTicket;
